import { IResourceContext, Parameter } from 'shell-models-lib';
import { MetadataModeService } from 'app/services/metadata-mode.service';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';

// Allow the parameter class to use the MetadataModeService. The shell models library does not have access to the Application injector.
Parameter.getMetadataModeService = (contextData: IResourceContext) => getServiceInstance<MetadataModeService>(contextData, 'MetadataModeService');

export { Parameter } from 'shell-models-lib';
